// services/classService.js
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";

const classesCollection = collection(db, "classes");

export const getClasses = async () => {
  const snapshot = await getDocs(classesCollection);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const createClass = async (classData) => {
  const docRef = await addDoc(classesCollection, classData);
  return docRef.id;
};

export const updateClass = async (classId, updatedData) => {
  const classDoc = doc(db, "classes", classId);
  await updateDoc(classDoc, updatedData);
};

export const deleteClass = async (classId) => {
  const classDoc = doc(db, "classes", classId);
  await deleteDoc(classDoc);
};

export const getClassesByUserId = async (userId) => {
  const q = query(classesCollection, where("userId", "==", userId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};
